__turbopack_context__.v({
  "buttonWithVolume": "ToggleRadioButton-module__xXMZoq__buttonWithVolume",
  "navItem": "ToggleRadioButton-module__xXMZoq__navItem",
  "paused": "ToggleRadioButton-module__xXMZoq__paused",
  "radioButton": "ToggleRadioButton-module__xXMZoq__radioButton",
  "scrollingTitle": "ToggleRadioButton-module__xXMZoq__scrollingTitle",
  "volumeSlider": "ToggleRadioButton-module__xXMZoq__volumeSlider",
  "volumeSliderContainer": "ToggleRadioButton-module__xXMZoq__volumeSliderContainer",
});
